<div class="wt-input wt-input-text"
     [class.wt-input--validate-on-blur]="validateOnBlur"
     [class.wt-input--focused]="isFocused"
     [class.wt-input-text--disabled]="disabled"
>
  <input class="wt-input__input {{additionalClass ? additionalClass : ''}}"
         [type]="inferredType"
         [id]="id"
         [disabled]="disabled"
         [class.wt-input__input--filled]="isFilled"
         [attr.aria-label]="ariaLabel ? ariaLabel : null"
         [attr.placeholder]="placeholder ? placeholder : null"
         [attr.maxlength]="maxLength ? maxLength : null"
         (blur)="onBlur(value)"
         (keyup)="onKeyup(value)"
         (focus)="onFocus()"
         [(ngModel)]="value"
         (paste)="onPaste()"
         #inputText
  />
  <label class="wt-input__label"
         *ngIf="label"
         [for]="id"
  >
    {{label}}
  </label>
  <div class="wt-input__error" *ngIf="isInvalid && (!validateOnBlur || !isFocused)">
    {{errorMessage}}
  </div>
</div>
